import * as React from 'react';
import styled from 'styled-components';
const StyleDiv = styled.div ``;
class IconEdit extends React.Component {
    render() {
        return (React.createElement(StyleDiv, { className: this.props.className },
            React.createElement("svg", { onClick: this.props.clicked, width: this.props.width, height: this.props.height, viewBox: "0 0 300 300" },
                React.createElement("g", null,
                    React.createElement("g", null,
                        React.createElement("path", { d: "M149.996,0C67.157,0,0.001,67.161,0.001,149.997S67.157,300,149.996,300s150.003-67.163,150.003-150.003\n                S232.835,0,149.996,0z M221.302,107.945l-14.247,14.247l-29.001-28.999l-11.002,11.002l29.001,29.001l-71.132,71.126\n                l-28.999-28.996L84.92,186.328l28.999,28.999l-7.088,7.088l-0.135-0.135c-0.786,1.294-2.064,2.238-3.582,2.575l-27.043,6.03\n                c-0.405,0.091-0.817,0.135-1.224,0.135c-1.476,0-2.91-0.581-3.973-1.647c-1.364-1.359-1.932-3.322-1.512-5.203l6.027-27.035\n                c0.34-1.517,1.286-2.798,2.578-3.582l-0.137-0.137L192.3,78.941c1.678-1.675,4.404-1.675,6.082,0.005l22.922,22.917\n                C222.982,103.541,222.982,106.267,221.302,107.945z" })))),
            this.props.children));
    }
}
;
export default IconEdit;
//# sourceMappingURL=IconEdit.js.map


// WEBPACK FOOTER //
// ./src/components/IconEdit.js